import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/scrollAnimations.css';
import './Offer.css';

const Offer = ({ title, description, image, worth, showWorth }) => {
  const [offerRef, offerVisible] = useScrollAnimation({ threshold: 0.1 });
  const [titleRef, titleVisible] = useScrollAnimation({ threshold: 0.2 });
  const [descriptionRef, descriptionVisible] = useScrollAnimation({ threshold: 0.2 });
  const [imageRef, imageVisible] = useScrollAnimation({ threshold: 0.1 });

  return (
    <div 
      ref={offerRef}
      className={`offer-wrapper ${offerVisible ? 'offer-visible' : ''}`}
    >
      <div className="offer">
        <div className="offer-left">
          {showWorth && <h5>{worth}</h5>}
          <div className="offer-header">
            <h3 
              ref={titleRef}
              className={`offer-title scroll-fade-in ${titleVisible ? 'is-visible' : ''}`}
            >
              {title}
            </h3>
            <img src="./img/verified_2.webp" alt="Icon" className="offer-icon" />
          </div>
          <p 
            ref={descriptionRef}
            className={`offer-description scroll-fade-in scroll-animation-delay-1 ${descriptionVisible ? 'is-visible' : ''}`}
          >
            {description}
          </p>
        </div>
        <img 
          ref={imageRef}
          src={image} 
          alt={title} 
          className={`offer-image ${imageVisible ? 'offer-image-visible' : ''}`}
        />
      </div>
    </div>
  );
};

export default Offer;
